import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiUsernamesAdd, uiUsernamesRemove } from "Store/Actions";
import { selectUsernames } from "Store/Selectors/UI";
import { IUseUsernames } from "./IUseUsernames";

export function useUsernames(): IUseUsernames {
  const dispatch = useDispatch();
  const [username, setUsername] = useState(``);
  const usernames = useSelector(selectUsernames);
  const onAddUser = useCallback(
    (name: string) => {
      setUsername(``);
      dispatch(uiUsernamesAdd([name]));
    },
    [dispatch]
  );
  const onRemoveUser = useCallback((name: string) => dispatch(uiUsernamesRemove([name])), [dispatch]);
  const onEditUser = useCallback(
    (name: string) => {
      onRemoveUser(name);
      setUsername(name);
    },
    [onRemoveUser]
  );

  return {
    usernames,
    username,
    onEditUser,
    onAddUser,
    onRemoveUser
  };
}
